import VehicleInspectionSelector, { makeSelectorOptions } from './VehicleInspectionSelector'
import VehicleInspectionSelectedOption from './VehicleInspectionSelectedOption'

export {
    VehicleInspectionSelectedOption,
    makeSelectorOptions,
}

export default VehicleInspectionSelector
